/* Paleta y constantes de marca — ver CLAUDE.md.
   Papel #F3F4F6 · tinta #17223B · marca #D6453D · acción #2B5FD9 */
export const TINTA = "#17223B";
export const MARCA = "#D6453D";
export const ACCION = "#2B5FD9";
export const MONO = "'SFMono-Regular', 'Menlo', 'Consolas', monospace";

// Colores disponibles para las anotaciones (5 colores).
export const COLORES = ["#D6453D", "#2B5FD9", "#1B8A5A", "#B7791F", "#17223B"];
